module.exports = __webpack_public_path__ + "img/prize-02.2a0f2f5e.png";